const AdditionalSearch = () => (
    <div>
        <h3>Wyszukanie dla frazy: "BAS"</h3>
    </div>
);

export default AdditionalSearch;
